(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["open-roles"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    fetch('https://boards-api.greenhouse.io/v1/boards/bobbie/departments', {
      method: 'GET',
      headers: {
        "Content-type": "text/plain"
      }
    }).then(data => data.text())
      .then(data => {
        const jsonResult = JSON.parse(data);
        const departmentsCount = jsonResult.departments.length;
        let departments = [];

        function generateDepartmentsArray() {
            for (let i = 0; i < departmentsCount; i++) {
                const departmentName = jsonResult.departments[i].name;
                const jobsInDepartment = jsonResult.departments[i].jobs.length;

                if (jobsInDepartment > 0) {
                    departments.push(departmentName);
                }
            }
        }

        function generateOptions() {
            generateDepartmentsArray();
            departments.forEach(createOption);

            function createOption(department) {
                const option = document.createElement("option");
                option.value = department;
                option.append(department);
                document.querySelector('.open-roles__filter').append(option);
            }
        }

        function generateJobList(departments) {
            if (departmentsCount > 0) {
                for (let i = 0; i < departmentsCount; i++) {
                    const departmentName = jsonResult.departments[i].name;
                    const jobsInDepartment = jsonResult.departments[i].jobs.length;
                    const list = document.createElement("ul");
                    const listItem = document.createElement("li");

                    if (departments.includes(departmentName)) {
                        if (jobsInDepartment > 0) {
                            list.classList.add("open-roles__list");
                            listItem.classList.add('open-roles__list-item', 'open-roles__list-item--head', 'h3');
                            listItem.append(departmentName);
                            list.append(listItem);

                            for (let j = 0; j < jobsInDepartment; j++) {
                                const jobTitle = jsonResult.departments[i].jobs[j].title;
                                const jobURL = jsonResult.departments[i].jobs[j].absolute_url;
                                const jobListItem = document.createElement("li");
                                const jobAnchor = document.createElement("a");

                                jobAnchor.setAttribute('href', jobURL);
                                jobAnchor.setAttribute('target', '_blank');
                                jobAnchor.append(jobTitle);
                                jobListItem.append(jobAnchor);
                                jobListItem.classList.add('open-roles__list-item', 'h4');
                                list.append(jobListItem);
                            }

                            document.querySelector('.open-roles__lists').append(list);
                        }
                    }
                }
            }
        }

        document.getElementById('open-roles').addEventListener('change', onChange);

        function onChange() {
            const value = this.value;

            document.querySelector('.open-roles__list').remove();

            if (value != 'Filter by Department') {
                departments = [];
                departments.push(value);
            } else {
                generateDepartmentsArray();
            }

            generateJobList(departments);
            this.closest('.open-roles').classList.add('aos-off');
        }

        generateOptions();
        generateJobList(departments);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parenting-complicated"] && !window.DesignMode) return;
  try {
    
const closeButtons = document.querySelectorAll('.parenting__cross-button');

closeButtons.forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const block = e.target.closest('.parenting__award');
    const input = block.querySelector('input[type="radio"]');
    input.checked = false;
  });
});


  } catch(e) { console.error(e); }
})();
})();
